<template>
  <v-container
    fill-height
    fluid
    grid-list-xl
  >
    <v-layout
      justify-center
      wrap
    >
      <v-flex
        xs12
      >        
        <material-card
          color="blue"
          title="Applications"
          text="Here are your currently configured applications for this subscripton"
        >
          <v-tooltip
            content-class="left"
            left
          >
            <v-btn 
              slot="activator"              
              fab 
              absolute 
              icon 
              round 
              top 
              right 
              @click="showAddApplicationDialog=true" 
              color="accent" 
              class="mr-3" 
              style="top:25px;" 
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
            Add an new application. Go on! You're gonna love it!
          </v-tooltip>

          <div>
            <v-text-field
              v-model="search"
              prepend-icon="mdi-magnify"
              label="Look for something..."
              single-line
              hide-details
              clearable
            ></v-text-field>
          </div>

          <v-data-table
            :headers="headers"
            :items="allApps"
            :search="search"            
            :loading="atmosAppsRefreshing"
            :pagination.sync="pagination"
          >
            <v-progress-linear v-slot:progress indeterminate></v-progress-linear>            
            <template
              slot="headerCell"
              slot-scope="{ header }"
            >
              <span
                class="subheading font-weight-light text-success text--darken-3"
                v-text="header.text"
              />
            </template>
            <template
              slot="items"
              slot-scope="{ item }"
            >
              <td class="text-xs-left text-no-wrap">
                <div>
                  <v-icon :color="item.status.state | toStatusColor">{{ item.status.state | toStatusIcon }}</v-icon>
                  <a @click="navigateToDetails(item.id)" style="color:inherit;">{{item.name}}</a>
                </div>
              </td>
              <td class="text-xs-left">{{item.status.state}}</td>
              <td class="text-xs-left" v-show="atmosSubscription.id == null">{{ atmosSubscriptions.find(s => s.id == item.subscription).name }}</td>
              <td class="text-xs-left hidden-sm-and-down">{{item.type}}</td>
              <td class="text-xs-left hidden-sm-and-down">{{item.version}}</td>
              <td class="text-xs-left hidden-sm-and-down">{{item.createdOn | formatDate}}</td>
              <td class="text-xs-left hidden-sm-and-down">{{item.expiresOn | formatDate}}</td>
              <td class="justify-center layout px-0">
                <v-icon
                  small
                  @click.stop="navigateToDetails(item.id)"
                  class="mr-2"
                >mdi-pencil</v-icon>
                <v-menu offset-y>
                  <template v-slot:activator="{ on }">
                    <v-icon small class="mr-2" v-on="on">mdi-dots-horizontal</v-icon>
                  </template>
                  <v-list>
                    <v-list-tile @click="upgradeApp(item)" :disabled="!actionableState(item.status.state) || !canUpgrade(item)">
                      <v-list-tile-title>Upgrade</v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile @click="confirmUndeployApp(item)" :disabled="!actionableState(item.status.state) || !canUndeploy(item)">
                      <v-list-tile-title>Undeploy</v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile @click="confirmDeployApp(item)" :disabled="!actionableState(item.status.state) || !canDeploy(item)">
                      <v-list-tile-title>Deploy</v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile @click="confirmRemoveApp(item)" :disabled="!actionableState(item.status.state)">
                      <v-list-tile-title>Delete</v-list-tile-title>
                    </v-list-tile>
                  </v-list>                
                </v-menu>
              </td>
            </template>
          </v-data-table>
        </material-card>
      </v-flex>
    </v-layout>

    <dialog-add-application 
      v-model="showAddApplicationDialog"
    />

    <dialog-upgrade-application 
      v-model="upgradeApplicationDialogSettings"
    />

    <dialog-confirm 
      v-model="showConfirmRemoveAppDialog" 
      title="Remove Application?" 
      :content="`Are you sure you want to remove the application '${(currentApp || '').name}'? All data associated with this instance will be deleted.`"
      :challenge="(currentApp || '').name"
      @confirm="removeApp(currentApp)"
    />

    <dialog-confirm 
      v-model="showConfirmUndeployAppDialog" 
      title="Undeploy Application?" 
      :content="`Are you sure you want to undeploy the application '${(currentApp || '').name}'?`"
      :challenge="(currentApp || '').name"
      @confirm="undeployApp(currentApp)"
    />

    <dialog-confirm 
      v-model="showConfirmDeployAppDialog" 
      title="Deploy Application?" 
      :content="`Are you sure you want to deploy the application '${(currentApp || '').name}'?`"
      @confirm="deployApp(currentApp)"
    />

  </v-container>
</template>

<script>
import store from '@/store'
import { mapActions, mapGetters } from 'vuex'
import AddApplicationDialog from '@/dialogs/AddApplicationDialog'
import UpgradeApplicationDialog from '@/dialogs/UpgradeApplicationDialog'
import ConfirmDialog from '@/dialogs/ConfirmDialog'
import semver from "semver";

export default {
  components: {
    'dialog-add-application': AddApplicationDialog,
    'dialog-upgrade-application': UpgradeApplicationDialog,
    'dialog-confirm' : ConfirmDialog,
  },
  
  data() {
    return {
      search: null,
      currentApp: null,
      showAddApplicationDialog: false,
      showConfirmRemoveAppDialog: false,
      showConfirmUndeployAppDialog: false,
      showConfirmDeployAppDialog: false,
      upgradeApplicationDialogSettings: {
        show: false,
        app: null,
      },
      // headers: [
      //   { text: 'Name', align: 'left', value: 'name' },
      //   { text: 'Status', align: 'left', value: 'status.state' },
      //   { text: 'Subscription', align: 'left', value: 'subscription' },
      //   { text: 'Type', align: 'left', value: 'type', class: 'hidden-sm-and-down' },
      //   { text: 'Version', align: 'left', value: 'version', class: 'hidden-sm-and-down' },
      //   { text: 'Created On', align: 'left', value: 'createdOn', class: 'hidden-sm-and-down' },
      //   { text: 'Expires On', align: 'left', value: 'expiresOn', class: 'hidden-sm-and-down' },
      //   { text: 'Actions', align: 'center', sortable: false, value: 'name' },
      // ],
      pagination: {
        rowsPerPage: 10
      }
    }
  },

  computed: {
    ...mapGetters('atmos', [
      'atmosInitialized',
      'atmosSubscription',
      'atmosSubscriptions',
      'atmosApps',
      'atmosAppsRefreshing',
      'atmosAppTypes',
      "showPrereleases",
      "showVersions",
    ]),

    headers() {
      var arr = [
        { text: 'Name', align: 'left', value: 'name' },
        { text: 'Status', align: 'left', value: 'status.state' }
      ];
        
      if (this.atmosSubscription.id == null) {
        arr.push({ text: 'Subscription', align: 'left', value: 'subscription' });
      }
      
      arr.push(
        { text: 'Type', align: 'left', value: 'type', class: 'hidden-sm-and-down' },
        { text: 'Version', align: 'left', value: 'version', class: 'hidden-sm-and-down' },
        { text: 'Created On', align: 'left', value: 'createdOn', class: 'hidden-sm-and-down' },
        { text: 'Expires On', align: 'left', value: 'expiresOn', class: 'hidden-sm-and-down' },
        { text: 'Actions', align: 'center', sortable: false, value: 'name' }
      );

      return arr;
    },

    allApps() {
      return this.atmosApps;
      // return this.atmosApps.map(i => {
      //   let item = Object.assign({}, i);
      //   item.type = this.atmosAppTypes[item.type].description;
      //   return item;
      // })
    }
  },

  filters: {
    toStatusIcon: function (value) {
      switch (value) {
        case 'Pending': return 'mdi-clock-outline'
        case 'Installing': return 'mdi-plus-circle-outline'
        case 'Upgrading' : return 'mdi-update'
        case 'OK': return 'mdi-play-circle-outline'
        case 'Suspect': return 'mdi-alert-circle-outline'
        case 'Uninstalling': return 'mdi-minus-circle-outline'
        case 'Undeploying': return 'mdi-minus-circle-outline'
        case 'Undeployed': return 'mdi-pause-circle-outline'
        case 'Deploying': return 'mdi-plus-circle-outline'
      }
    },

    toStatusColor: function (value) {
      switch (value) {
        case 'Pending': return 'info'
        case 'Installing': return 'info'
        case 'Upgrading' : return 'info'
        case 'OK': return 'success'
        case 'Suspect': return 'error'
        case 'Uninstalling': return 'info'
        case 'Undeploying': return 'info'
        case 'Undeployed': return 'warning'
        case 'Deploying': return 'info'
      }
    }
  },

  methods: {
    ...mapActions('atmos', [
      'atmosRefreshApps',
      'atmosRemoveApplication',
      'atmosUndeployApplication',
      'atmosDeployApplication'
    ]),

    canUndeploy(app) {
      return app.status.state == "OK" || app.status.state == "Suspect";
    },

    canDeploy(app) {
      return app.status.state == "Undeployed";
    },
    
    canUpgrade(app) {      
      //if the current app is a preview, then no
      if (!semver.valid(app.version)) {
        return false;
      }
      
      if (semver.prerelease(app.version)) {
        return false;
      }

      //get the list of versions for this type
      var list = null;
      if (this.showPrereleases) {
        list = this.atmosAppTypes[app.type].versions
      } else {
        list = this.atmosAppTypes[app.type].versions.filter(v => semver.valid(v.version) && !semver.prerelease(v.version));
      }
      
      //sort the list
      list = list.map(i => { return { name:i.version, value:i } } );
      list = list.sort((a,b) => { 
        if (semver.valid(a) && semver.valid(b)) {
          return semver.lt(a.value, b.value) 
        }
        return 1;
      });

      if (list.length > 0) {
        return semver.gte(list[0].name, app.version);
      } else {
        return false;
      }
    },

    confirmUndeployApp(app) {
      this.currentApp = app;
      this.showConfirmUndeployAppDialog = true;
    },

    async undeployApp(app) {
      await this.atmosUndeployApplication(this.currentApp.name);
    },

    confirmDeployApp(app) {
      this.currentApp = app;
      this.showConfirmDeployAppDialog = true;
    },

    async deployApp(app) {
      await this.atmosDeployApplication(this.currentApp.name);
    },

    upgradeApp(app) {
      this.upgradeApplicationDialogSettings = { app: app, show: true};
    },

    navigateToDetails(id) {
      this.$router.push({ name: 'Application', params: { id: id } });
    },

    confirmRemoveApp(app) {
      this.currentApp = app;
      this.showConfirmRemoveAppDialog = true;
    },

    actionableState(state) {
      return state == "OK" || state == "Suspect" || state == "Undeployed";
    },

    async removeApp() {
      await this.atmosRemoveApplication(this.currentApp.name);
    },

  }  

}
</script>
